import React from "react";
import "./Float.css";
import {BrowserRouter as Router, Link} from 'react-router-dom'

const Float = ({className}) => {
  return (
    <div className="float">
      <ul>
        <li>
          <Router>
            <Link
              to="https://www.linkedin.com/in/yathishshettigar"
              target="_blank"
            >
              <img width={40} height={40} 
                // loading="lazy"
                src="https://ik.imagekit.io/35sznjvlf/assets/LinkedInlinkedin.png?updatedAt=1719465272851"
                alt=""
              />
            </Link>
          </Router>
        </li>
        <li>
          <Router>
            <Link to="https://github.com/yathish1204" target="_blank">
              <img width={40} height={40} 
                // loading="lazy"
                src="https://ik.imagekit.io/35sznjvlf/assets/GitHubgithubTeal.png?updatedAt=1719465266542"
                alt=""
              />
            </Link>
          </Router>
        </li>
        <li>
          <Router>
            <Link to="https://www.behance.net/yathishshettigar" target="_blank">
              <img width={40} height={40} 
                // loading="lazy"
                src="https://ik.imagekit.io/35sznjvlf/assets/Behancebehance.png?updatedAt=1719465260081"
                alt=""
              />
            </Link>
          </Router>
        </li>
        <li>
          <Router>
            <Link
              to="https://x.com/YathishShe57208?t=iFvwUTfSou16Fb42c2Ilhg&s=08"
              target="_blank"
            >
              <img width={40} height={40} 
                // loading="lazy"
                src="https://ik.imagekit.io/35sznjvlf/assets/Twittertwitter.png?updatedAt=1719465283739"
                alt=""
              />
            </Link>
          </Router>
        </li>
        <li>
          <Router>
            <Link
              to="https://www.instagram.com/y_shettigar2001?utm_source=qr&igsh=MWFwc2s2ZHR3NTJi"
              target="_blank"
            >
              <img
                loading="lazy"
                src="https://ik.imagekit.io/35sznjvlf/assets/instagraminsta.png?updatedAt=1719465272196"
                alt=""
              />
            </Link>
          </Router>
        </li>
      </ul>
    </div>
  );
};

export default Float;
